import { CheckoutCheckoutRequestSchema } from '~/services/api/generated'

const limit = CheckoutCheckoutRequestSchema.def.right.shape.tip.unwrap().unwrap().maxValue
if (limit === null) throw new RangeError('The checkout contract defines no tip limit')

/** The largest gratuity amount the checkout contract accepts. */
export const tipLimit: number = limit
